// extracted by mini-css-extract-plugin
export default {"events-summary-item":"styles_events-summary-item__nWfan","active":"styles_active__EBsZ6"};